module.exports = __webpack_public_path__ + "img/魏嘉楠.803869a9.jpg";